export default function massAssignDocumentCategory(params) {
    const records = this.dataGet(params.prefix + '/selected');
    this.popup('ListviewDocumentMassAssignCategory', {...params, records: records});
}
